import { ReportAttributes, ReportRelationships } from 'dashboard/models/report';
import { ApiModel, ApiResource } from 'lib/interfaces/api';

export enum CaliforniaAttorneyGeneralStatus {
  MayOperate = 'May Operate or Solicit for Charitable Purposes',
  MayNotOperate = 'May Not Operate or Solicit for Charitable Purposes',
  NotOperating = 'Not Operating or In Process of Dissolving',
  Undetermined = 'Undetermined',
}

export interface ReportBusinessNonprofitAttributes extends ReportAttributes {
  query: {
    ein: string;
  };
  result?: {
    'organization-name'?: string;
    'organization-name-aka'?: string;
    address?: {
      'street-1'?: string;
      'street-2'?: string;
      city?: string;
      subdivision?: string;
      'postal-code'?: string;
      'country-code'?: string;
    };
    'foundation-type-code'?: string;
    'foundation-type-description'?: string;
    'irs-filing-requirement-code'?: string;
    'irs-pub-78-details'?: {
      'church-message'?: string;
      'organization-name'?: string;
      ein?: string;
      verified?: boolean;
      city?: string;
      state?: string;
      'organization-types'?: [
        {
          'organization-type'?: string;
          'deductibility-limitation'?: string;
          'deductibility-status-description'?: string;
        },
      ];
      'most-recent-pub78'?: string;
      'most-recent-irb'?: string;
    };
    'irs-bmf-details'?: {
      'church-message'?: string;
      'organization-name'?: string;
      ein?: string;
      status?: boolean;
      'most-recent-bmf'?: string;
      subsection?: string;
      'subsection-description'?: string;
      'ruling-month'?: string;
      'ruling-year'?: string;
    };
    'ca-ag-details'?: {
      status?: CaliforniaAttorneyGeneralStatus;
      'registry-status'?: string;
      'state-charity-reg-num'?: string;
      'issue-date'?: string;
      'last-renewal-date'?: string;
      'status-set-date'?: string;
      'as-of-date'?: string;
      'most-recent-ag'?: string;
    };
    'ca-ftb-details'?: {
      'revocation-status'?: boolean;
      'revocation-status-date'?: string;
      'most-recent-ftb'?: string;
    };
  };
}

export type ReportBusinessNonprofit = ApiResource<
  ReportBusinessNonprofitAttributes,
  ReportRelationships,
  ApiModel.ReportBusinessNonprofit
>;
